import { jsx as _jsx } from "react/jsx-runtime";
import { DeleteContactModal } from '../DeleteContactModal/DeleteContactModal';
import { useContactRowModal } from './useContactRowModal';
export const useDeleteContactModal = (testId)=>useContactRowModal('delete_contact_modal', (contact, dismissModal)=>/*#__PURE__*/ _jsx(DeleteContactModal, {
            contact: contact,
            dismissModal: dismissModal,
            testId: testId
        }));
